// PaymentInputModal.js - VERSIÓN COMPLETA CORREGIDA CON PROPINA
import React, { useState, useEffect } from "react";
import "../styles/PaymentInputModal.css";

const PaymentInputModal = ({ 
  method, 
  total, 
  appliedPayments, 
  onConfirm, 
  onClose,
  property,
  currentUser,
  chequeSeleccionado,
  mostrarMensaje,
  order,
  selectedRevenue,
  selectedSpace,
  deviceConfig,
  propertyConfig,
  revenues,
  // Datos de la consulta de habitación (desde Hotel.js) - OPCIONAL
  consultaHotelData = null
}) => {
  // ==============================================
  // CÁLCULOS INICIALES
  // ==============================================
  const totalPagado = appliedPayments.reduce((sum, p) => sum + parseFloat(p.amount.toFixed(2)), 0);
  const restante = parseFloat((total - totalPagado).toFixed(2));
  const isHotelPayment = method.Hotel === "Y";
  
  // ==============================================
  // ESTADOS
  // ==============================================
  const [step, setStep] = useState(() => {
    if (isHotelPayment && method.PM) {
      return "monto";
    } else if (isHotelPayment && !method.PM && !consultaHotelData) {
      return "roomNumber";
    } else {
      return "monto";
    }
  });
  
  const [amount, setAmount] = useState("");
  const [tip, setTip] = useState(method.Tip === "Y" ? "" : "0");
  const [folio, setFolio] = useState("");
  const [roomNumber, setRoomNumber] = useState(method.PM || consultaHotelData?.roomNumber || "");
  const [useFullAmount, setUseFullAmount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentModo, setCurrentModo] = useState(null);
  const [consultaData, setConsultaData] = useState(consultaHotelData);

  // ==============================================
  // CÁLCULO DE CAMBIO
  // ==============================================
  const calculateChange = () => {
    const amountNumber = parseFloat(amount) || 0;
    if (method.Change === "Y") {
      return parseFloat((amountNumber - restante).toFixed(2));
    }
    return 0;
  };
  const cambio = calculateChange();

  // ==============================================
  // DETERMINAR MODO DE VENTA
  // ==============================================
  useEffect(() => {
    if (isHotelPayment && propertyConfig?.ifac_hotel === "Y" && propertyConfig?.ifac_hdepto) {
      determinarModoVentaActual();
    }
  }, [propertyConfig, method, selectedRevenue]);

  const determinarModoVentaActual = () => {
    if (!propertyConfig?.ifac_hdepto || !Array.isArray(propertyConfig.ifac_hdepto)) return;

    const currentDepto = selectedRevenue?.Depto ? selectedRevenue.Depto.toString() : "1";
    const now = new Date();
    const currentTime = now.toTimeString().slice(0, 8);
    const currentHour = now.getHours();

    const modosDepto = propertyConfig.ifac_hdepto.filter(item => 
      item.depto === currentDepto && item.hotel === "Y"
    );

    if (modosDepto.length === 0) return;

    let modoDeterminado = null;
    
    for (const modo of modosDepto) {
      if (currentTime >= modo.inicio && currentTime <= modo.fin) {
        modoDeterminado = modo;
        break;
      }
    }

    if (!modoDeterminado) {
      if (currentHour >= 6 && currentHour < 13) {
        modoDeterminado = modosDepto.find(m => m.modo === "Desayunos");
      } else if (currentHour >= 13 && currentHour < 18) {
        modoDeterminado = modosDepto.find(m => m.modo === "Comida");
      } else {
        modoDeterminado = modosDepto.find(m => m.modo === "Cena");
      }
    }

    setCurrentModo(modoDeterminado);
  };

  // ==============================================
  // EFFECT PARA USAR MONTO COMPLETO
  // ==============================================
  useEffect(() => {
    if (useFullAmount && step === "monto") {
      setAmount(restante.toString());
    }
  }, [useFullAmount, restante, step]);

  // ==============================================
  // FUNCIÓN PARA CONSULTAR HABITACIÓN
  // ==============================================
  const consultarHabitacion = async () => {
    if (!roomNumber.trim()) {
      mostrarMensaje("❌ Ingresa el número de habitación");
      return false;
    }

    if (!/^\d+$/.test(roomNumber)) {
      mostrarMensaje("❌ El número de habitación debe contener solo dígitos");
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {
      const url = `https://www.bts.ei-solutions.co/shopeis/app_menu/consultar-habitacion.php?property=${encodeURIComponent(property)}&roomNumber=${encodeURIComponent(roomNumber)}`;
      
      console.log("🔍 Consultando habitación:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log("📥 Respuesta consulta:", data);

      if (!data.success) {
        mostrarMensaje(`❌ ${data.message || "Error en consulta"}`);
        return false;
      }

      if (data.noPost === true) {
        mostrarMensaje("❌ Esta habitación tiene NoPost activo");
        return false;
      }

      if (data.creditLimit === 0 || data.creditLimit === null || data.creditLimit === undefined) {
        mostrarMensaje("❌ Esta habitación no tiene crédito disponible");
        return false;
      }

      if (data.creditLimit <= 0) {
        mostrarMensaje("❌ Crédito insuficiente");
        return false;
      }

      setConsultaData(data);
      mostrarMensaje(`✅ Habitación ${roomNumber} válida - Límite: $${data.creditLimit}`);
      return true;

    } catch (error) {
      console.error("❌ Error en consulta:", error);
      mostrarMensaje(`❌ Error: ${error.message}`);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // ==============================================
  // MANEJADORES DEL TECLADO
  // ==============================================
  const handleKeyPress = (value, setter) => {
    if (value === "C") {
      setter("");
      if (setter === setAmount) setUseFullAmount(false);
    } else if (value === "←") {
      setter((prev) => prev.slice(0, -1));
      if (setter === setAmount) setUseFullAmount(false);
    } else {
      setter((prev) => prev + value);
      if (setter === setAmount) setUseFullAmount(false);
    }
  };

  const handleRoomKeyPress = (value) => handleKeyPress(value, setRoomNumber);
  const handleAmountKeyPress = (value) => handleKeyPress(value, setAmount);
  const handleTipKeyPress = (value) => handleKeyPress(value, setTip);

  const handleFolioKeyPress = (e) => {
    if (e.key === 'Enter') handleContinue();
  };

  // ==============================================
  // MANEJADOR PRINCIPAL
  // ==============================================
  const handleContinue = async () => {
    if (step === "roomNumber") {
      const consultaExitosa = await consultarHabitacion();
      if (consultaExitosa) setStep("monto");
      return;
    }
    
    if (step === "monto") {
      if (!amount && !useFullAmount) {
        setUseFullAmount(true);
        setAmount(restante.toString());
        return;
      }
      
      const amountNum = parseFloat(amount);
      if (isNaN(amountNum) || amountNum <= 0) {
        mostrarMensaje("❌ Ingresa un monto válido");
        return;
      }
      
      setStep(method.Tip === "Y" ? "tip" : method.Folio === "Y" ? "folio" : "confirm");
      return;
    }
    
    if (step === "tip") {
      const tipNum = parseFloat(tip) || 0;
      if (tipNum < 0) {
        mostrarMensaje("❌ La propina no puede ser negativa");
        return;
      }
      setStep(method.Folio === "Y" ? "folio" : "confirm");
      return;
    }
    
    if (step === "folio") {
      setStep("confirm");
      return;
    }
    
    if (step === "confirm") {
      handleConfirm();
    }
  };

  // ==============================================
  // CONFIRMAR PAGO - CON PROPINA INCLUIDA
  // ==============================================
  const handleConfirm = () => {
    const amountNumber = parseFloat(amount) || 0;
    const tipNumber = parseFloat(tip) || 0;
  
    const montoFinal = parseFloat(amountNumber.toFixed(2));
    const propinaFinal = parseFloat(tipNumber.toFixed(2));
  
    const cambioCalculado = method.Change === "Y" 
      ? parseFloat((montoFinal - restante).toFixed(2))
      : 0;

    const roomNumberToUse = method.PM || consultaData?.roomNumber || roomNumber;
    const numeroCheque = chequeSeleccionado?.toString() || "0";
    const mesaReal = selectedRevenue?.Tipo === "Retail" ? "Retail" : `Mesa ${selectedSpace?.name || ""}`.trim();
    
    // Preparar subtotales del pedido
    const subtotales = order.map(item => ({
      descripcion: item.name,
      cantidad: item.quantity || 1,
      precio: item.price || 0,
      total: (item.quantity || 1) * (item.price || 0)
    }));

    // ✅ AGREGAR PROPINA COMO ÍTEM SEPARADO
    if (propinaFinal > 0) {
      subtotales.push({
        descripcion: "Propina",
        cantidad: 1,
        precio: propinaFinal,
        total: propinaFinal
      });
    }

    const subtotal = subtotales.reduce((sum, item) => sum + item.total, 0);
    const iva = subtotal * 0.16;
    
    let deptoToSend = "1";
    if (selectedRevenue?.Depto) {
      deptoToSend = selectedRevenue.Depto.toString();
    } else if (selectedRevenue?.id) {
      deptoToSend = selectedRevenue.id.toString();
    } else if (revenues && Array.isArray(revenues)) {
      const revenueConfig = revenues.find(r => r.name === selectedRevenue?.name);
      if (revenueConfig?.Depto) deptoToSend = revenueConfig.Depto.toString();
      else if (revenueConfig?.id) deptoToSend = revenueConfig.id.toString();
    }

    const datosPreparados = {
      habitacion: {
        numero: roomNumberToUse,
        reservationId: consultaData?.reservationId,
        profileId: consultaData?.profileId,
        guestName: consultaData?.guestName,
        creditLimit: consultaData?.creditLimit,
        noPost: consultaData?.noPost
      },
      pago: {
        metodo: method.name,
        metodoId: method.id?.toString() || "11",
        monto: montoFinal,
        propina: propinaFinal,
        total: montoFinal + propinaFinal,
        cambio: cambioCalculado,
        folio: folio
      },
      cuenta: {
        numeroCheque: numeroCheque,
        departamento: deptoToSend,
        revenueName: selectedRevenue?.name || "",
        revenueId: selectedRevenue?.id?.toString() || "0",
        revenueTipo: selectedRevenue?.Tipo || "Table",
        mesa: mesaReal,
        modoVenta: currentModo?.modo || "room",
        servingTime: currentModo?.modo === "Desayunos" ? "1" : 
                     currentModo?.modo === "Comida" ? "2" : "3"
      },
      items: subtotales,
      totales: {
        subtotal: subtotal,
        iva: parseFloat(iva.toFixed(2)),
        total: subtotal + parseFloat(iva.toFixed(2)),
        pagado: montoFinal + propinaFinal
      },
      metadata: {
        property: property,
        usuario: currentUser?.nombre || "SISTEMA",
        workstation: deviceConfig?.name || "POS-01",
        timestamp: new Date().toISOString(),
        referencia: `CHK-${numeroCheque}-${Date.now()}`
      }
    };

    console.log("📦 DATOS PREPARADOS CON PROPINA:", {
      propina: propinaFinal,
      datosPreparados
    });

    let mensaje = `✅ Datos preparados para ${isHotelPayment ? 'hotel' : 'pago'}\n`;
    mensaje += `📋 Cheque #${numeroCheque}\n`;
    mensaje += `💰 Total: $${(montoFinal + propinaFinal).toFixed(2)}`;
    if (propinaFinal > 0) mensaje += `\n💝 Propina: $${propinaFinal.toFixed(2)}`;
    
    mostrarMensaje(mensaje);
    
    // ✅ PASAR PROPINA EXPLÍCITAMENTE
    onConfirm({
      amount: montoFinal,
      tip: propinaFinal,
      change: cambioCalculado,
      folio,
      method: method,
      isHotelPayment,
      datosPreparados,
      consultaData,
      roomNumber: roomNumberToUse,
      numeroCheque,
      depto: deptoToSend,
      propinaAplicada: propinaFinal
    });
    
    onClose();
  };

  // ==============================================
  // RETROCEDER
  // ==============================================
  const handleBack = () => {
    if (step === "monto" && isHotelPayment && !method.PM && !consultaHotelData) {
      setStep("roomNumber");
    } else if (step === "tip") {
      setStep("monto");
    } else if (step === "folio") {
      setStep(method.Tip === "Y" ? "tip" : "monto");
    } else if (step === "confirm") {
      setStep(method.Folio === "Y" ? "folio" : method.Tip === "Y" ? "tip" : "monto");
    }
  };

  // ==============================================
  // RENDERIZADO DE PASOS
  // ==============================================
  const renderStep = () => {
    if (step === "roomNumber") {
      return (
        <>
          <label className="payment-modal__label">Número de Habitación</label>
          <input 
            className="payment-modal__input" 
            value={roomNumber} 
            readOnly 
            placeholder="Ej: 101, 205, 820"
          />
          {currentModo && (
            <div className="payment-modal__modo-info">
              <small><i className="fas fa-clock"></i> Modo: {currentModo.modo}</small>
            </div>
          )}
          <Keypad onKey={handleRoomKeyPress} />
          <div className="payment-modal__note">
            <small>Ingresa solo el número de habitación</small>
          </div>
        </>
      );
    }
    
    if (step === "monto") {
      return (
        <>
          <label className="payment-modal__label">
            Monto a pagar (Restante: ${restante.toFixed(2)})
          </label>
          <input 
            className="payment-modal__input" 
            value={amount} 
            readOnly 
            placeholder="Ingresa el monto"
          />
          
          <div className="payment-modal__full-amount-button">
            <button 
              onClick={() => { setUseFullAmount(true); setAmount(restante.toString()); }}
              disabled={useFullAmount || restante <= 0}
              className={useFullAmount ? "active" : ""}
            >
              {useFullAmount ? "✓ Monto completo" : `Usar monto completo ($${restante.toFixed(2)})`}
            </button>
          </div>
          
          <Keypad onKey={handleAmountKeyPress} />
          
          {isHotelPayment && (method.PM || consultaData) && (
            <div className="payment-modal__hotel-info">
              <div className="hotel-info-card">
                <p><i className="fas fa-door-closed"></i> <strong>Habitación:</strong> {method.PM || consultaData?.roomNumber}</p>
                {consultaData?.guestName && (
                  <p><i className="fas fa-user"></i> <strong>Huésped:</strong> {consultaData.guestName}</p>
                )}
                {consultaData?.creditLimit > 0 && (
                  <p><i className="fas fa-credit-card"></i> <strong>Límite:</strong> ${consultaData.creditLimit}</p>
                )}
              </div>
            </div>
          )}
        </>
      );
    }
    
    if (step === "tip") {
      return (
        <>
          <label className="payment-modal__label">Propina (opcional)</label>
          <input 
            className="payment-modal__input" 
            value={tip} 
            readOnly 
            placeholder="Ingresa la propina"
          />
          <Keypad onKey={handleTipKeyPress} />
        </>
      );
    }
    
    if (step === "folio") {
      return (
        <>
          <label className="payment-modal__label">Folio / Referencia</label>
          <input 
            className="payment-modal__input" 
            value={folio} 
            onChange={(e) => setFolio(e.target.value)}
            onKeyPress={handleFolioKeyPress}
            placeholder="Ingresa folio o referencia"
            autoFocus
          />
        </>
      );
    }
    
    return (
      <div className="payment-modal__summary">
        <h4>Resumen del Pago</h4>
        
        {isHotelPayment && (method.PM || consultaData) && (
          <div className="summary-row room-info">
            <span className="summary-label"><i className="fas fa-door-closed"></i> Habitación:</span>
            <span className="summary-value">{method.PM || consultaData?.roomNumber}</span>
          </div>
        )}
        
        {isHotelPayment && consultaData?.guestName && (
          <div className="summary-row guest-info">
            <span className="summary-label"><i className="fas fa-user"></i> Huésped:</span>
            <span className="summary-value">{consultaData.guestName}</span>
          </div>
        )}
        
        <div className="summary-row">
          <span className="summary-label">Desde:</span>
          <span className="summary-value">
            {selectedRevenue?.Tipo === "Retail" ? "Retail" : `Mesa: ${selectedSpace?.name}`}
          </span>
        </div>
        
        <div className="summary-row">
          <span className="summary-label">Cheque #:</span>
          <span className="summary-value">{chequeSeleccionado || "N/A"}</span>
        </div>
        
        <div className="summary-row">
          <span className="summary-label">Método:</span>
          <span className="summary-value">{method.name}</span>
        </div>
        
        <div className="summary-row">
          <span className="summary-label">Monto:</span>
          <span className="summary-value">${parseFloat(amount || 0).toFixed(2)}</span>
        </div>
        
        {method.Tip === "Y" && parseFloat(tip || 0) > 0 && (
          <div className="summary-row highlight">
            <span className="summary-label">💝 Propina:</span>
            <span className="summary-value">${parseFloat(tip || 0).toFixed(2)}</span>
          </div>
        )}
        
        {method.Folio === "Y" && folio && (
          <div className="summary-row">
            <span className="summary-label">Folio:</span>
            <span className="summary-value">{folio}</span>
          </div>
        )}
        
        {method.Change === "Y" && cambio > 0 && (
          <div className="summary-row highlight">
            <span className="summary-label">Cambio:</span>
            <span className="summary-value">${cambio.toFixed(2)}</span>
          </div>
        )}

        <div className="preparacion-nota">
          <p>
            <i className="fas fa-info-circle"></i> 
            Al confirmar se PREPARARÁN los datos. El cargo se hará después.
          </p>
        </div>
      </div>
    );
  };

  const renderStepIndicator = () => {
    const steps = [];
    
    if (isHotelPayment && !method.PM && !consultaHotelData) {
      steps.push(
        <span key="room" className={step === "roomNumber" ? "active" : ""}>
          Habitación
        </span>
      );
    }
    
    steps.push(<span key="monto" className={step === "monto" ? "active" : ""}>Monto</span>);
    
    if (method.Tip === "Y") {
      steps.push(<span key="tip" className={step === "tip" ? "active" : ""}>Propina</span>);
    }
    
    if (method.Folio === "Y") {
      steps.push(<span key="folio" className={step === "folio" ? "active" : ""}>Folio</span>);
    }
    
    steps.push(<span key="confirm" className={step === "confirm" ? "active" : ""}>✓</span>);
    
    return <div className="payment-modal__step-indicator">{steps}</div>;
  };

  return (
    <div className="payment-modal__overlay">
      <div className="payment-modal__container">
        <div className="payment-modal__header">
          <h3 className="payment-modal__title">
            {method.name}
            {method.PM && ` (Hab. ${method.PM})`}
            {isHotelPayment && !method.PM && <span className="hotel-badge"> 🏨 Hotel</span>}
          </h3>
          <button onClick={onClose} className="payment-modal__close-btn">×</button>
        </div>
        
        {renderStepIndicator()}
        
        <div className="payment-modal__input-container">
          {renderStep()}
        </div>
        
        <div className="payment-modal__buttons">
          {step !== "roomNumber" && step !== "monto" && step !== "confirm" && (
            <button 
              className="payment-modal__button payment-modal__button--back" 
              onClick={handleBack}
              disabled={isLoading}
            >
              <i className="fas fa-arrow-left"></i> Atrás
            </button>
          )}
          
          <button 
            className="payment-modal__button payment-modal__button--confirm" 
            onClick={handleContinue}
            disabled={
              isLoading || 
              (step === "folio" && !folio.trim() && method.Folio === "Y")
            }
          >
            {isLoading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Consultando...
              </>
            ) : step === "confirm" ? (
              "PREPARAR DATOS"
            ) : step === "monto" && !amount ? (
              "Usar monto restante"
            ) : (
              "Siguiente"
            )}
          </button>
          
          {step !== "confirm" && (
            <button 
              className="payment-modal__button payment-modal__button--cancel" 
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </button>
          )}
        </div>
        
        <div className="payment-modal__nota">
          <p className="nota-preparacion">
            ⚠️ Este modal SOLO PREPARA los datos. El cargo real se hará después.
          </p>
        </div>
      </div>
    </div>
  );
};

const Keypad = ({ onKey }) => {
  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "←", "C"];
  
  return (
    <div className="payment-modal__keypad">
      {keys.map((k) => (
        <button 
          key={k} 
          onClick={() => onKey(k)}
          className={
            k === "←" ? "key-backspace" : 
            k === "C" ? "key-clear" : 
            k === "." ? "key-decimal" : 
            ""
          }
        >
          {k === "←" ? <i className="fas fa-backspace"></i> : 
           k === "C" ? <i className="fas fa-times-circle"></i> : 
           k}
        </button>
      ))}
    </div>
  );
};

export default PaymentInputModal;